module.exports = __webpack_public_path__ + "img/tyvm-akira.9b7d4fa2.png";